<template>
  <!-- قسم التوصيات -->
  <section class="section recommend-section" v-if="todayOffers.length">
    <div class="container-fluid">
      <!-- عنوان القسم -->
      <div class="row">
        <div class="col-lg-12 mx-auto">
          <div
            class="section-heading heading-three mx-auto"
            data-aos="fade-down"
          >
            <h2>عروض <span>اليوم</span></h2>
            <p>إليك قائمة بأحدث السيارات المعروضة اليوم</p>
          </div>
        </div>
      </div>
      <!-- /Title section  -->

      <div class="row">
        <div class="col-md-12">
          <div class="recommend-slider owl-carousel">
            <Carousel
              :wrap-around="true"
              :autoplay="3000"
              :settings="settings"
              :breakpoints="breakpoints"
            >
              <Slide v-for="item in todayOffers" :key="item.id">
                <div class="listing-item bike-list">
                  <div class="listing-img">
                    <router-link :to="`/listing/${item.id}`">
                      <img
                        :src="
                          item.images[0]?.image ||
                          require('@/assets/img/cars/no-car.jpg')
                        "
                        class="img-fluid"
                        alt="car"
                      />
                    </router-link>
                  </div>
                  <div class="listing-content">
                    <div
                      class="listing-features d-flex justify-content-between"
                    >
                      <div class="list-rating">
                        <!-- مفيش تقييمات في الريسبونس، ممكن نشيلهم أو نعمل قيمة افتراضية -->
                        <!-- <div class="list-ratings">
                          <i class="fas fa-star filled me-1"></i>
                          <i class="fas fa-star filled me-1"></i>
                          <i class="fas fa-star filled me-1"></i>
                          <i class="fas fa-star filled me-1"></i>
                          <i class="fas fa-star"></i>
                          <span>0</span>
                        </div> -->
                        <div>
                          <span class="featured-text">{{
                            timeAgo(item.created_at)
                          }}</span>
                        </div>
                        <span class="featured-text"
                          >{{ item.brand?.name }} - {{ item.model?.name }}</span
                        >
                      </div>
                      <div class="list-km">
                        <span class="km-count"
                          ><img
                            src="@/assets/img/icons/map-pin.svg"
                            alt="author"
                          />{{ item.city?.name }} - {{ item.district?.name }}
                        </span>
                      </div>
                    </div>
                    <div class="listing-details-group">
                      <ul>
                        <li>
                          <span>
                            <img
                              src="@/assets/img/icons/bike-icon-01.svg"
                              alt="gear"
                          /></span>
                          <p>{{ item.gear }}</p>
                        </li>
                        <li>
                          <span>
                            <img
                              src="@/assets/img/icons/bike-icon-02.svg"
                              alt="fuel"
                          /></span>
                          <p>{{ item.fuel_type }}</p>
                        </li>
                        <li>
                          <span>
                            <img
                              src="@/assets/img/icons/bike-icon-03.svg"
                              alt="year"
                          /></span>
                          <p>{{ item.year }}</p>
                        </li>
                        <li>
                          <span>
                            <img
                              src="@/assets/img/icons/bike-icon-04.svg"
                              alt="color"
                          /></span>
                          <p>{{ item.color }}</p>
                        </li>
                      </ul>
                    </div>
                    <div class="listing-button">
                      <!-- <div class="listing-price">
                        <h6>{{ item.price }} <span>جنيه</span></h6>
                      </div> -->
                      <div class="listing-price">
                        <h6 v-if="item.rent_or_sale == 'rent'">
                          ${{ item.price?.daily }}
                          <span>/ يوم</span>
                        </h6>
                        <h6 v-else-if="item.rent_or_sale == 'installment'">
                          ${{ item.installment?.price }}
                        </h6>
                        <h6 v-else>${{ item.price }}</h6>
                      </div>
                      <div class="d-flex align-items-center">
                        <a
                          href="javascript:void(0)"
                          class="fav-icon"
                          @click="toggleSelected(item)"
                          :class="{ selected: item.is_fav }"
                        >
                          <i class="feather-heart"></i>
                        </a>
                        <router-link
                          :to="`/listing/${item.id}`"
                          class="btn btn-order"
                          >شوف تفاصيل</router-link
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </Slide>
              <template #addons></template>
            </Carousel>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { Carousel, Slide } from "vue3-carousel";
import "vue3-carousel/dist/carousel.css";
import { useHomeStore } from "@/stores/home";
import { onMounted, computed } from "vue";
import { useFavoriteStore } from "@/stores/favorite";

export default {
  components: {
    Carousel,
    Slide,
  },
  setup() {
    const homeStore = useHomeStore();
    const favoriteStore = useFavoriteStore();

    onMounted(() => {
      homeStore.fetchHomeData();
    });

    const todayOffers = computed(() => homeStore.recommended);

    const toggleSelected = (item) => {
      favoriteStore.toggleFavorite(item.id);
      
      item.isSelected = !item.isSelected;
      item.is_fav = !item.is_fav;
    };

    const settings = {
      itemsToShow: 1,
      snapAlign: "center",
    };

    const breakpoints = {
      575: { itemsToShow: 1, snapAlign: "center" },
      767: { itemsToShow: 2, snapAlign: "center" },
      991: { itemsToShow: 3, snapAlign: "center" },
      1024: { itemsToShow: 3, snapAlign: "start" },
    };

    return {
      todayOffers,
      settings,
      breakpoints,
      toggleSelected,
    };
  },
  methods: {
    timeAgo(date) {
      if (!date) return "";
      const now = new Date();
      const created = new Date(date);
      const diff = Math.floor((now - created) / 1000);

      if (diff < 60) return "منذ ثوانٍ";
      if (diff < 3600) return `منذ ${Math.floor(diff / 60)} دقيقة`;
      if (diff < 86400) return `منذ ${Math.floor(diff / 3600)} ساعة`;
      if (diff < 2592000) return `منذ ${Math.floor(diff / 86400)} يوم`;
      if (diff < 31104000) return `منذ ${Math.floor(diff / 2592000)} شهر`;
      return `منذ ${Math.floor(diff / 31104000)} سنة`;
    },
  },
};
</script>

<style scoped>
.recommend-section {
  margin-top: 20px;
}
</style>
